import { SET_DISPLAY_NODE } from "constants/app";

export default (state = null, action) => {
  switch (action.type) {
    case SET_DISPLAY_NODE:
      return action.value;
    default:
      return state;
  }
};
